import { meetingTypes } from "../config/meetingOptions.js";
import { formatNice } from "../utils/formatNice.js";

export const REALTIME_TURN_DETECTION = {
  type: "server_vad",
  threshold: 0.85,
  prefix_padding_ms: 300,
  silence_duration_ms: 3000,
  create_response: true,
  interrupt_response: false,
};

export const REALTIME_NOISE_REDUCTION = {
  type: "near_field",
};

export const labelFor = (value, options = meetingTypes) => {
  const match = options.find((option) => option.value === value);
  return match?.label || formatNice(value || "");
};

export const sanitizeText = (value, max = 1200) => String(value || "").trim().slice(0, max);

export const summarizeConversation = (conversation = []) => {
  if (!Array.isArray(conversation) || !conversation.length) return "No prior turns yet.";
  return conversation
    .slice(-6)
    .map((turn, idx) => {
      const user = String(turn?.user || "").trim() || "-";
      const ai = String(turn?.ai || "").trim() || "-";
      return `${idx + 1}. User: ${user}\n   AI: ${ai}`;
    })
    .join("\n");
};
